import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import { colorsPalette, SMALL_MARGIN } from '../../../../theme';

const useStyles = makeStyles(() =>
  createStyles({
    breadcrumbs: {
      position: 'relative',
      marginBottom: SMALL_MARGIN,
      marginTop: 0,
      '& .MuiBreadcrumbs-separator': {
        color: colorsPalette.white,
        fontWeight: 700,
      },
    },
    crumb: {
      color: colorsPalette.white,
      fontWeight: 700,
      textTransform: 'capitalize',
      fontSize: 16,
    },
    lastCrumb: {
      color: colorsPalette.gray,
      fontWeight: 400,
      textTransform: 'capitalize',
      fontSize: 16,
    },
  }),
);

export default useStyles;
